var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVsLogoDarkRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 93.55 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#fff;}.c{fill:#c20000;}.d{mix-blend-mode:hard-light;}.e{isolation:isolate;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "e"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M50.05,20.6c-1.35-.37-2.62-.71-2.62-1.48,0-1.37,3.92-3.57,5.62-3.75,.17-.01,.35-.03,.49-.03,.51,0,.87,.12,.8,.55-.17,1.21-2.77,2.7-3.32,2.7-.08,0-.16,0-.16-.08,0-.19,.08-.47,.28-.69-.27,.16-.79,.73-.79,1.28,0,.29,.4,.4,.67,.4,1.41,0,3.73-1.72,3.76-3.3,.01-1.03-.8-1.32-2.01-1.28-1.94,.07-6.25,1.85-6.25,4.09,0,1.17,1.81,1.41,3.41,1.85,1.31,.36,2.41,.85,2.41,1.68,0,2.01-6.5,5.22-9.71,5.22-.43,0-1.12-.01-1.12-.53,0-.99,3.38-3.93,6.91-4.89-1.72-.04-7.74,3.14-7.74,5.11,0,1.05,1.28,1.31,2.16,1.31,3.64,0,10.27-2.85,10.27-5.76,0-1.48-1.56-1.97-3.06-2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M56.71,20.41c.16-.23,.77-.77,1-.87,.15-.07,.25-.01,.28-.01,.05,0-.03-.2-.15-.33-.17-.2-.47-.47-.77-.43-.35,.11-.85,.97-.84,1.36,.01,.24,.29,.52,.48,.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M71.8,20.35c-1.17,0-3.09,1-3.3,2.01-.04,.17,0,.34,.09,.48-.95,.89-2.36,2.15-3.05,2.34,.03-.63,2.09-3.44,2.43-3.7,.17-.15-.25-.87-.57-.87-.45,0-2.8,1.8-4.29,3.26-.28,.27-.53,.53-.68,.75,.2-.37,.89-1.36,1.52-2.18,.4-.52,.89-1.08,1.07-1.07,.11,.01,.16,.08,.16,.03,0-.33-.51-.85-.84-.85-.04,0-.12,.01-.17,.07-.35,.27-.93,.97-1.41,1.65-.44,.61-.95,1.4-1.27,2.02-.03,.05-.05,.09-.07,.14-.25,.08-.5,.17-.75,.26l.81-1.5c.23-.45,.29-.41,.33-.37,.05-.16-.51-.88-.76-.76-.23,.11-.43,.31-1.35,1.08-.44,.37-1.07,.87-1.71,1.29-.59,.39-1.12,.73-1.17,.68-.13-.11,.84-1.74,2.11-2.82,.88-.73,1.84-1.29,2.61-1.33,.4-.03,.65,.17,.65,.57,0,.2-.08,.36-.13,.48-.01,.01,0,.03,.03,.01,.12-.17,.25-.4,.25-.63,0-.63-.67-.84-1.19-.84-1.77,0-3.86,1.56-4.88,2.97-.84,.75-1.79,1.53-2.3,1.66,.16-.55,1.99-3.58,2.53-3.53,.11,.01,.17,.08,.17,.03,0-.33-.53-.87-.84-.87-.05,0-.13,.01-.2,.08-.85,.68-2.79,3.58-2.79,4.35,0,.24,.33,.57,.55,.64,.07,.01,.11,.01,.16,.01,.47-.04,1.37-.76,2.26-1.61-.11,.25-.17,.48-.17,.68,0,.27,.33,.75,.57,.89,.04,.03,.11,.04,.13,.04,.28,0,1.07-.57,1.83-1.16,.75-.59,1.48-1.24,1.68-1.42,.25-.23,.59-.47,.57-.45,0,0-1.12,2.01-1.41,2.52-3.06,1.46-5.69,3.62-6.22,5.31-.07,.2-.09,.37-.09,.52,0,.56,.41,.79,.91,.79,.15,0,.29-.01,.44-.05,2.56-.68,4.76-4.02,6.46-6.99,.26-.11,.53-.23,.8-.34-.19,.41-.23,.66-.21,.74,.11,.39,.43,.81,.83,.72-.2-.09-.11-.45,.25-.88,.15-.19,.31-.39,.48-.56,.99-1.07,2.94-2.68,4.04-3.17-.69,.63-2.24,2.85-2.24,3.61,0,.15,.09,.35,.24,.52,.13,.16,.28,.28,.41,.28,.69,0,2.38-1.62,3.58-2.87,.21,.28,.51,.47,.59,.58,.03,.04,.08,.18,.08,.22,0,.61-1.65,1.4-2.17,1.54,.02-.02,1.06-1.12,1.14-1.2,.09-.08,.12-.21-.15,.02-.07,.06-1.32,.92-1.33,1.32-.04,.51,.21,.53,.51,.53,.87,0,2.62-.7,2.81-1.57,.04-.28-.29-.68-.44-.84-.04-.05-.12-.12-.18-.17-.13-.12-.42-.3-.36-.53,.17-.63,2.24-1.89,2.85-1.84-.03,.27-.92,1.2-.96,1.2-.01,0,.01,.05,.03,.05,.36,0,1.2-.8,1.21-.99,.04-.39-.13-1-.51-1Zm-17.53,10.62c-.21,.11-.44,.19-.63,.19-.17,0-.29-.07-.29-.25,0-.13,.07-.32,.21-.59,.93-1.73,2.79-3.25,5.21-4.53-1.36,2.2-2.95,4.34-4.5,5.18Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M73.1,21.08c.01,.09,.01,.18,0,.26,0,.09-.19,.31-.43,.52,5.35-.93,11.16-2.25,12.16-2.99,.07-.1-5.64,1.26-11.74,2.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M40.13,23.34c-20.39-.03-36.58-2.1-36.73-4.41-.02-.31,.25-.58,.77-.89C2.1,18.27-.01,19.46,0,20.43c.13,3.65,23.83,4.66,37.17,4.44,1.39-.02,2.83-.06,4.31-.12,.76-.53,1.62-1.03,2.45-1.44-1.22,.02-2.48,.02-3.8,.02Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "18.48 .24 12.95 9.86 14.02 .24 7.37 .24 5.65 18.03 14.63 18.04 25.14 .24 18.48 .24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5,.24l-1.55,4.52,1.42,.16-7.76,13.12h6.68l1-1.6h3.73v1.6h6.71L38.47,.25h-11.97Zm4.19,11.9h-2.17l2.89-5.2-.71,5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.55,.26h-11.81l-2.51,3.01-3.91,11.36,.64,3.42h11.25l2.94-3.17,3.99-11.6-.59-3.02Zm-8.28,11.61l-.7,.76h-2.19l-.2-1.12,2.08-5.66,.75-.9h2.17l.21,1.11-2.12,5.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.31,3.29l-.59-3.02h-14.78l-1.61,4.67h1.5l-4.52,13.12h6.36l1.53-4.45,.51,4.45h6.52l1.85-5.39h-2.16l3.32-3.29,2.09-6.09Zm-7.18,3.55l-.67,.66h-2.6l1.05-3.09h2.47l.21,1.09-.45,1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.46,3.28l-.59-3.02h-14.78l-1.61,4.67h1.5l-4.52,13.12h6.36l1.85-5.39h6.57l3.13-3.28,2.09-6.09Zm-7.04,3.48l-.7,.73h-2.6l1.05-3.09h2.46l.21,1.1-.42,1.26Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "d"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "16.45 3.77 23.05 3.77 23.35 3.26 16.75 3.26 16.45 3.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "21.19 6.93 21.57 6.28 15.01 6.28 14.64 6.92 21.19 6.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "20.24 8.53 20.69 7.78 14.15 7.78 13.71 8.53 20.24 8.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "22.12 5.35 22.47 4.76 15.88 4.76 15.55 5.35 22.12 5.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "13.85 1.74 7.22 1.73 7.18 2.16 13.81 2.16 13.85 1.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "24.93 .59 25.14 .24 18.48 .24 18.28 .59 24.93 .59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "19.8 9.28 13.28 9.28 12.95 9.86 13.01 9.28 6.49 9.27 6.41 10.1 19.31 10.11 19.8 9.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "7.37 .24 7.33 .58 13.98 .59 14.02 .24 7.37 .24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "24 2.17 24.25 1.74 17.62 1.74 17.38 2.16 24 2.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "17.12 13.82 6.06 13.82 5.96 14.86 16.5 14.87 17.12 13.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "18.9 10.8 6.35 10.8 6.26 11.68 18.38 11.68 18.9 10.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "18.02 12.3 6.2 12.29 6.11 13.28 17.43 13.29 18.02 12.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "16.23 15.32 5.91 15.32 5.8 16.44 15.57 16.44 16.23 15.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "15.33 16.84 5.76 16.84 5.65 18.03 14.63 18.04 15.33 16.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "13.18 7.78 6.64 7.78 6.57 8.52 13.1 8.53 13.18 7.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "13.52 4.76 6.93 4.75 6.87 5.34 13.45 5.35 13.52 4.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "13.68 3.26 7.08 3.26 7.03 3.76 13.63 3.77 13.68 3.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "13.35 6.28 6.78 6.28 6.72 6.92 13.28 6.92 13.35 6.28"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "75.29 12.32 74.95 13.31 89.85 13.32 90.07 12.67 87.91 12.67 88.25 12.33 75.29 12.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "76.33 9.3 76.05 10.13 90.46 10.14 91.22 9.38 91.25 9.31 76.33 9.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "77.37 6.31 77.15 6.95 83.04 6.95 83.26 6.31 77.37 6.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "81.57 16.87 81.71 18.07 88.23 18.07 88.64 16.87 81.57 16.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "76.4 4.78 76.34 4.94 77.84 4.94 77.69 5.37 83.58 5.38 83.78 4.79 76.4 4.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "86.44 4.79 86.56 5.38 92.6 5.38 92.8 4.79 86.44 4.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "77.43 1.76 77.29 2.19 93.1 2.2 93.02 1.77 77.43 1.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "77.95 .27 77.83 .61 92.79 .62 92.73 .27 77.95 .27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "76.85 7.81 76.59 8.55 91.51 8.56 91.76 7.81 76.85 7.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "81.23 13.85 81.35 14.89 89.31 14.9 89.67 13.85 81.23 13.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "75.81 10.83 75.51 11.71 88.87 11.71 89.76 10.83 75.81 10.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "81.4 15.35 81.53 16.47 88.77 16.47 89.16 15.35 81.4 15.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "86.31 6.31 86.13 6.84 86.02 6.95 92.06 6.96 92.28 6.31 86.31 6.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "76.91 3.29 76.74 3.79 93.14 3.8 93.31 3.29 76.91 3.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "80.08 16.87 73.73 16.87 73.32 18.06 79.68 18.06 80.08 16.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "74.25 15.34 73.87 16.47 80.22 16.47 80.61 15.35 74.25 15.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "74.77 13.85 74.41 14.89 80.76 14.89 81.12 13.85 74.77 13.85"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "63.18 11.52 63.44 10.82 57.63 10.82 57.33 11.7 63.21 11.7 63.18 11.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "58.16 9.29 57.87 10.12 63.69 10.13 64 9.3 58.16 9.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "58.67 7.8 58.41 8.55 64.27 8.55 64.55 7.8 58.67 7.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "59.19 6.3 58.97 6.94 64.86 6.94 65.1 6.3 59.19 6.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "70.72 15.34 56.45 15.34 56.66 16.46 69.69 16.47 70.72 15.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "61.49 1.76 61.14 2.18 74.93 2.19 74.84 1.76 61.49 1.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "62.74 .26 62.45 .61 74.62 .61 74.55 .26 62.74 .26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "60.23 3.28 60.05 3.79 74.96 3.79 75.14 3.29 60.23 3.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "67.76 7.8 67.49 8.55 73.33 8.55 73.59 7.8 67.76 7.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "59.51 5.36 65.67 5.37 66.01 4.96 68.18 4.96 68.26 5.37 74.42 5.37 74.62 4.78 59.71 4.78 59.51 5.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "68.31 6.3 68.07 6.95 73.88 6.95 74.1 6.31 68.31 6.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "67.22 9.3 66.91 10.13 72.79 10.13 73.07 9.3 67.22 9.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "56.32 14.63 56.37 14.88 71.15 14.89 71.15 14.88 71.51 13.85 56.59 13.84 56.32 14.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "65.86 12.32 65.57 12.63 63.38 12.63 63.32 12.32 57.12 12.32 56.78 13.31 71.69 13.31 72.03 12.32 65.86 12.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "68.21 18.06 69.32 16.87 56.74 16.86 56.96 18.05 68.21 18.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "66.66 10.82 66.34 11.7 72.24 11.71 72.55 10.83 66.66 10.82"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "39.92 13.83 39.56 14.88 45.91 14.88 46.27 13.84 39.92 13.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "42.06 3.27 41.89 3.78 58.29 3.79 58.46 3.28 42.06 3.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "51.71 4.77 51.83 5.36 57.75 5.36 57.95 4.78 51.71 4.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "51.43 6.76 51.26 6.94 57.21 6.94 57.43 6.3 51.58 6.3 51.43 6.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "42.58 1.75 42.44 2.18 58.25 2.18 58.17 1.75 42.58 1.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "40.96 10.81 40.66 11.69 54.16 11.7 55 10.82 40.96 10.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "43.1 .25 42.98 .6 57.94 .6 57.88 .26 43.1 .25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "40.44 12.31 40.1 13.3 46.45 13.3 46.67 12.65 53.25 12.66 53.57 12.31 40.44 12.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "39.02 16.45 45.37 16.46 45.76 15.33 39.4 15.33 39.02 16.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "42 7.79 41.74 8.54 56.66 8.55 56.91 7.8 42 7.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "42.52 6.29 42.3 6.93 48.32 6.94 48.54 6.3 42.52 6.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "41.55 4.77 41.49 4.93 42.99 4.93 42.84 5.36 48.85 5.36 49.05 4.77 41.55 4.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "41.49 9.29 41.2 10.12 55.66 10.12 56.38 9.37 56.4 9.29 41.49 9.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "45.24 16.86 38.88 16.85 38.47 18.05 44.83 18.05 45.24 16.86"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "37.04 14.87 37.14 13.83 21.1 13.82 20.49 14.87 37.04 14.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "37.2 13.3 37.29 12.31 22 12.3 21.42 13.29 37.2 13.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "25.99 1.74 25.84 2.17 38.29 2.17 38.33 1.75 25.99 1.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "36.89 16.45 37 15.33 20.22 15.32 19.55 16.44 26.29 16.45 26.29 16.44 30.02 16.44 30.02 16.45 36.89 16.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "26.37 4.92 26.11 5.35 37.97 5.36 38.03 4.77 24.97 4.76 26.37 4.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "26.5 .24 26.38 .59 38.44 .6 38.47 .25 26.5 .24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "38.13 3.78 38.18 3.27 25.46 3.26 25.29 3.77 38.13 3.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "36.85 16.85 30.02 16.85 30.02 18.04 36.73 18.05 36.85 16.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "26.04 16.85 19.32 16.85 18.61 18.04 25.29 18.04 26.04 16.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "23.79 9.28 23.3 10.11 29.65 10.11 30.11 9.28 23.79 9.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "37.35 11.69 37.44 10.81 30.88 10.81 30.75 11.69 37.35 11.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "22.89 10.8 22.37 11.69 28.77 11.69 29.26 10.81 22.89 10.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "24.67 7.78 24.23 8.53 30.52 8.53 30.94 7.79 24.67 7.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "37.51 10.11 37.59 9.29 31.08 9.28 30.97 10.11 37.51 10.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "31.19 8.53 37.66 8.54 37.74 7.79 31.29 7.79 31.19 8.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "25.56 6.29 25.18 6.93 37.82 6.93 37.88 6.29 25.56 6.29"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14.76,18.27H5.39L7.15,0h7.13l-.98,8.76L18.35,0h7.2L14.76,18.27Zm-8.85-.47H14.49L24.73,.48h-6.11l-6.03,10.47L13.76,.47H7.58l-1.67,17.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M36.94,18.28h-7.16v-1.61h-3.37l-1,1.6h-7.22l7.78-13.16-1.35-.15L26.33,0h12.4l-1.79,18.27Zm-6.69-.47h6.26L38.22,.48h-11.55l-1.4,4.08,1.49,.17-7.73,13.08h6.14l1-1.6h4.1v1.6Zm.64-5.43h-2.78l3.69-6.64-.91,6.64Zm-1.98-.47h1.57l.52-3.75-2.08,3.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M68.31,18.29h-11.55l-.69-3.68,3.94-11.46L62.63,.02h12.12l.64,3.28-4.02,11.7-3.04,3.29Zm-11.16-.47h10.95l2.84-3.06,3.95-11.49-.54-2.77h-11.51l-2.42,2.9-3.87,11.26,.59,3.17Zm8.52-4.95h-2.49l-.24-1.37,2.12-5.75,.85-1.01h2.47l.26,1.36-2.16,5.91-.81,.87Zm-2.1-.47h1.9l.6-.65,2.08-5.7-.17-.85h-1.86l-.65,.78-2.05,5.56,.15,.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M88.4,18.3h-6.9l-.41-3.63-1.24,3.63h-6.86l4.52-13.12h-1.5L77.78,.03h15.14l.64,3.28-2.13,6.2-2.95,2.92h1.92l-2.01,5.87Zm-6.48-.47h6.14l1.69-4.92h-2.41l3.68-3.65,2.05-5.98-.54-2.77h-14.42l-1.44,4.2h1.5l-4.52,13.12h5.86l1.81-5.28,.6,5.28Zm3.64-10.09h-3.03l1.21-3.56h2.75l.1,.14,.02,.06,.22,1.14-.49,1.45-.78,.77Zm-2.37-.47h2.18l.56-.56,.41-1.23-.16-.84h-2.1l-.89,2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M44.99,18.28h-6.86l4.52-13.12h-1.5L42.93,.02h15.14l.64,3.28-2.12,6.2-3.23,3.4h-6.51l-1.85,5.39Zm-6.2-.47h5.86l1.85-5.39h6.64l3.02-3.17,2.05-5.98-.54-2.77h-14.42l-1.44,4.2h1.5l-4.52,13.12Zm12.04-10.09h-3.03l1.21-3.56h2.77l.09,.19,.23,1.16-.46,1.37-.8,.84Zm-2.37-.47h2.17l.59-.62,.39-1.15-.17-.85h-2.1l-.89,2.62Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVsLogoDarkRed);
export default __webpack_public_path__ + "static/media/vs_logo_dark_red.4aaefc8e5c16fb76162bf3e05df1ccb1.svg";
export { ForwardRef as ReactComponent };